import { Box, Flex, ThemeUIStyleObject } from 'theme-ui';
import React from 'react';

export interface CheckboxProps extends React.ComponentPropsWithRef<'input'> {
  large?: boolean;
  variant?: string;
  sx?: ThemeUIStyleObject;
}

const Checkbox = React.forwardRef<HTMLInputElement, CheckboxProps>(({ variant, large, sx, ...props }, ref) => (
  <Box
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      position: 'relative',
      width: large ? 24 : 16,
      height: large ? 24 : 16
    }}
  >
    <input
      {...props}
      ref={ref}
      type="checkbox"
      sx={{
        // Make sure the checkbox is invisible but still rendered, so it can be focused
        position: 'absolute',
        zIndex: -1,
        overflow: 'hidden',
        width: 1,
        height: 1,
        opacity: 0
      }}
    />
    <Flex
      aria-hidden="true"
      variant={variant?.includes('.') ? variant : `forms.${variant}`}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        width: '100%',
        height: '100%',
        ...sx
      }}
    >
      {large ? (
        <svg width="12" height="8" viewBox="0 0 12 8" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M1.5 4L4.5 7L10.5 1"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M1 3L3 5L7 1" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      )}
    </Flex>
  </Box>
));

Checkbox.displayName = 'Checkbox';

Checkbox.defaultProps = {
  large: false,
  variant: 'checkbox'
};

export default Checkbox;
